import { Flex } from '@banhala/ui-kit';
import { isNil } from 'shared/src/utils';
import React, { useMemo } from 'react';
import { WebView } from 'shared/src/component/WebWebView';

export const HomeWebView: React.FC<{
  url?: string;
}> = props => {
  const url = useMemo(() => {
    if (isNil(props.url)) return undefined;
    const parsed = new URL(props.url);
    parsed.searchParams.set('global_layout', 'app');
    return parsed.toString();
  }, [props.url]);

  if (isNil(url)) return null;

  return (
    <Flex flex={1}>
      <WebView style={{ flex: 1 }} source={{ uri: url }} />
    </Flex>
  );
};
